import React, { useContext, useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  TextField,
  InputAdornment,
  Button,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
//Icons
import { LuSearch } from "react-icons/lu";
import romdul from "../../Assets/romdul.png";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";

//Srcs
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import FooterPagination from "../../Components/Include/FooterPagination";
import { GET_ACADEMIC_YEAR_PAGINATION, UPDATE_ACADEMIC_YEAR_STATUS } from "../../Schema/AcademicYear";
import { useMutation, useQuery } from "@apollo/client";

import AcademicYearForm from "../../Components/AcademicYear/AcademicYearForm";
import AcademicYearAction from "../../Components/AcademicYear/AcademicYearAction";
import moment from "moment";

export default function AcademicYear() {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(true);

  const [openCreate, setOpenCreate] = useState(false);
  const handleOpen = () => setOpenCreate(true);
  const handleClose = () => setOpenCreate(false);

  const [tableData, setTableData] = useState();
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { refetch } = useQuery(GET_ACADEMIC_YEAR_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
    },
    onCompleted: ({ getAcademicYearPagination }) => {
      setTableData(getAcademicYearPagination?.data);
      setPaginationData(getAcademicYearPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const [updateAcademicYearStatus] = useMutation(UPDATE_ACADEMIC_YEAR_STATUS, {
    onCompleted: ({ updateAcademicYearStatus }) => {
      // console.log("updateAcademicYearStatus::", updateAcademicYearStatus);
      if (updateAcademicYearStatus?.is_success) {
        setAlert(true, "success", updateAcademicYearStatus?.message);
        refetch();
      } else {
        setAlert(true, "error", updateAcademicYearStatus?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id) => {
    updateAcademicYearStatus({
      variables: {
        id: id,
      },
    });
  };


  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      "&::before, &::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
      "&::before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      "&::after": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/setting">
              <Typography
                className={language === "kh" ? "page-title-kh" : "page-title"}
              >
                {t(`page-setting`)}
              </Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="slash-title">/</Typography>
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`academic_year`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`label-search`)}
            </Typography>
            <TextField
              placeholder={t(`label-search`)}
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#158843", fontSize: "22px" }}
                  >
                    <LuSearch />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 10 }}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create-style"
                startIcon={
                  // <img src={romdul} alt="romdul" className="icon-add" />
                  <AddToPhotosIcon className="icon-add" />
                }
              >
                <Typography
                  className={language === "kh" ? "btn-txt-kh" : "btn-txt"}
                >
                  {t("btn-create")}
                </Typography>
              </Button>
            </Stack>
            <AcademicYearForm
              open={openCreate}
              dialogTitle="Create"
              handleClose={handleClose}
              setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-start"
                      : "header-title-start-kh"
                  }
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("academic_year")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("start_date")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("end_date")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_status")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("remark")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >

                </TableCell>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-end"
                      : "header-title-end-kh"
                  }
                ></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="table-body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="table-body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row?.is_active)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-start"
                                  : "body-cell-start-kh"
                              }
                            >
                              {index + 1}
                            </TableCell>

                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.academic_year}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {moment(row?.start_date)?.format("DD-MM-YYYY")}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {moment(row?.end_date)?.format("DD-MM-YYYY")}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >

                              <Stack
                                justifyContent="center"
                                alignItems="center"
                                className={
                                  row?.is_active === false ? "inactive-status-acdY" : "active-status-acdY"
                                }
                              >
                                <Typography className={language === "en" ? "status-txt" : "status-txt-kh"}>

                                  {row?.is_active === false ? t("in_active") : t("active")}
                                </Typography>
                              </Stack>

                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.remark}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              <FormControlLabel
                                control={
                                  <Android12Switch
                                    disabled={
                                      row?.is_active === true ? true : false
                                    }
                                    checked={row?.is_active}
                                    onChange={() =>
                                      handleUpdateStatus(
                                        row?._id,
                                      )
                                    }
                                  />
                                }
                              />
                            </TableCell>

                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-end"
                                  : "body-cell-end-kh"
                              }
                              align="right"
                            >
                              <AcademicYearAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
        // setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
